import { useEffect } from "react"

import { isBannedAddress } from "@/address/constants/banned"
import { ROUTES } from "@/common/constants/routes"
import { useRouter } from "@/common/hooks/useRouter"
import { useMultichainAccount } from "@/web3/hooks/useMultichainAccount"

type OFACProviderProps = {
  children: React.ReactNode
}

export const OFACProvider = ({ children }: OFACProviderProps) => {
  const { multichainAccount, disconnect } = useMultichainAccount()
  const { address } = multichainAccount
  const { reload } = useRouter()
  // biome-ignore lint: biome-migration
  useEffect(() => {
    if (address && disconnect) {
      const bannedAddress = isBannedAddress(address)

      if (bannedAddress) {
        disconnect(ROUTES.page500())
      }
    }
  }, [address, disconnect, reload])

  return <>{children}</>
}
